export default class ErrorView {
  constructor({
    log,
    element,
  }) {
    this.log = log
    this.element = element
  }

  show({message}) {
    this.element.classList.remove("dn")
    if (message.error) {
      this.element.querySelector("[data-error-message]").innerText = message.error.statusText
    }
    else {
      this.element.querySelector("[data-error-message]").innerText = message
    }
    this.element.style.display = "block"
  }

  hide() {
    this.element.classList.remove("db")
    this.element.style.display = "none"
  }
}
